import React from "react";
import { FaCheckCircle, FaHourglassHalf, FaSearch, FaVoteYea } from "react-icons/fa";

export default function VotesHero({
  totalCount = 0,
  pendingCount = 0,
  answeredCount = 0,
  filteredCount = 0,
}) {
  return (
    <section className="relative overflow-hidden rounded-[2rem] bg-slate-950 p-5 text-white shadow-xl shadow-slate-950/10 sm:p-6">
      <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-sky-500/30 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-20 -left-20 h-44 w-44 rounded-full bg-violet-500/30 blur-3xl" />

      <div className="relative">
        <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.28em] text-sky-200">
          <FaVoteYea className="text-[0.7rem]" />
          Participation club
        </p>

        <div className="mt-3 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="text-2xl font-bold tracking-tight sm:text-3xl">
              Votes & Sondages
            </h2>

            <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-200">
              Consulte les votes actifs du club, réponds pendant la période
              ouverte et retrouve facilement les sondages auxquels tu as déjà
              participé.
            </p>
          </div>

          <div className="grid grid-cols-3 gap-2 sm:min-w-[360px]">
            <HeroStat icon={FaVoteYea} label="Actifs" value={totalCount} />
            <HeroStat icon={FaHourglassHalf} label="À faire" value={pendingCount} />
            <HeroStat icon={FaCheckCircle} label="Répondus" value={answeredCount} />
          </div>
        </div>

        <div className="mt-3 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-3 py-1.5 text-xs font-semibold text-slate-200 backdrop-blur">
          <FaSearch className="text-sky-200" />
          {filteredCount} résultat{filteredCount > 1 ? "s" : ""} affiché
          {filteredCount > 1 ? "s" : ""}
        </div>
      </div>
    </section>
  );
}

function HeroStat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/10 p-3 text-center backdrop-blur">
      <div className="mx-auto flex h-9 w-9 items-center justify-center rounded-xl bg-white/15">
        <Icon className="text-sm text-white" />
      </div>

      <p className="mt-2 text-lg font-bold leading-none">{value}</p>
      <p className="mt-1 text-[11px] font-medium text-slate-300">{label}</p>
    </div>
  );
}